exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tab--active[data-v-0d6c8ef1]{background-color:#eee;font-weight:700}", ""]);

// exports
